"use strict";

export default {
  setTransaction(state, payload) {
    state.transactions = payload;
  },
};
